import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Avatar,
} from "@mui/material";
import {
  Info as InfoIcon,
  Warning as WarningIcon,
  Error as ErrorIcon,
  CheckCircle as SuccessIcon,
} from "@mui/icons-material";

const AlertDialog = ({
  open,
  onClose,
  title = "Alert",
  message,
  severity = "info", // 'info', 'warning', 'error', 'success'
  confirmText = "OK",
  showCancel = false,
  cancelText = "Cancel",
  onConfirm,
}) => {
  const getIcon = () => {
    switch (severity) {
      case "warning":
        return <WarningIcon />;
      case "error":
        return <ErrorIcon />;
      case "success":
        return <SuccessIcon />;
      default:
        return <InfoIcon />;
    }
  };

  const getColor = () => {
    switch (severity) {
      case "warning":
        return "#ff9800";
      case "error":
        return "#f44336";
      case "success":
        return "#4caf50";
      default:
        return "#2196f3";
    }
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
        },
      }}
    >
      <DialogTitle
        sx={{
          borderBottom: "2px solid #e3f2fd",
          pb: 3,
          mb: 2,
        
          px: 4,
          py: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Avatar
            sx={{
              bgcolor: getColor(),
              width: 40,
              height: 40,
            }}
          >
            {getIcon()}
          </Avatar>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 600, color: "#1565c0" }}>
              {title}
            </Typography>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ px: 4, py: 3 }}>
        <Typography variant="body1" sx={{ lineHeight: 1.6 }}>
          {message}
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          px: 4,
          pb: 4,
          pt: 2,
       
          gap: 2,
        }}
      >
        {showCancel && (
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              borderRadius: 3,
              textTransform: "none",
              fontWeight: 600,
              px: 4,
              py: 1.5,
              borderWidth: 2,
              color: "#1565c0",
              "&:hover": {
                borderWidth: 2,
                backgroundColor: "#e3f2fd",
              },
            }}
          >
            {cancelText}
          </Button>
        )}
        <Button
          onClick={handleConfirm}
          variant="contained"
          sx={{
            borderRadius: 3,
            textTransform: "none",
            fontWeight: 600,
            px: 4,
            py: 1.5,
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
